import { render, staticRenderFns } from "./AnswerPhoneText.vue?vue&type=template&id=03a1c055&"
import script from "./AnswerPhoneText.vue?vue&type=script&lang=js&"
export * from "./AnswerPhoneText.vue?vue&type=script&lang=js&"
import style0 from "./AnswerPhoneText.vue?vue&type=style&index=0&id=03a1c055&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports